/**
 * Error that is thrown when a something has gone wrong trying to upload an asset
 */
export class UploadFailedError extends Error {
    constructor(message, file) {
        super(message);
        Object.defineProperty(this, "file", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = 'UploadFailedError';
        this.file = file;
    }
}
//# sourceMappingURL=UploadFailedError.js.map